import React from 'react';

const Research2026 = () => {
  const partners = [
    {
      name: "Justin King",
      role: "Speed Development",
      partnership: "partnered with L.I.G. Sports Group",
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      )
    },
    {
      name: "Michael Susi",
      role: "Rest and Recovery",
      partnership: "",
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
        </svg>
      )
    },
    {
      name: "Team Beast Mode",
      role: "Personal Training",
      partnership: "",
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 4v12l-4-2-4 2V4M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      )
    },
    {
      name: "Uber for Teens",
      role: "Customizable Transportation",
      partnership: "",
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 17l4 4 4-4m-4-5v9m-8-9l4-4 4 4m0 0V3" />
        </svg>
      )
    }
  ];

  const partnerImages = {
    "Justin King": "/assets/Justin.King.png",
    "Michael Susi": "/assets/Mike.Susi.png",
    "Team Beast Mode": "/assets/Team.Beast.Mode.png"
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-spi-600 py-20 relative overflow-hidden">
        <div 
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage: `url('/assets/DTS_Warm_Up_Daniel_Farò_Photos_ID7099.jpg')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        />
        <div className="relative max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-light text-white mb-6">
            Research & Development 2026
          </h1>
          <p className="text-xl text-spi-100 leading-relaxed mb-8">
            A Pilot for Integrating Academic, Athletic, and Mental Health Development
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <a 
              href="mailto:sonom.advantage@gmail.com" 
              className="bg-white text-spi-600 px-6 py-3 rounded-lg font-medium hover:bg-gray-50 transition-colors"
            >
              Apply Now
            </a>
            <a 
              href="#program-details" 
              className="border-2 border-spi-100 text-spi-100 px-6 py-3 rounded-lg font-medium hover:bg-spi-100 hover:text-spi-600 transition-colors"
            >
              Learn More
            </a>
          </div>
          <div className="flex justify-center">
            <a 
              href="/family-portal" 
              className="text-spi-100 hover:text-white text-sm font-medium underline underline-offset-4"
            >
              Current Families: Access Your Portal →
            </a>
          </div>
        </div>
      </section>

      {/* Program Overview */}
      <section className="py-16 bg-gray-50" id="program-details">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-light text-gray-900 mb-6">Pilot Program Overview</h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              Our four-month research and development program starting in August 2026 delivers a high-impact model that integrates four pillars of development:
            </p>
          </div>
          
          <div className="bg-white rounded-lg shadow-sm p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Program Details</h3>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-spi-600 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-600"><strong>Duration:</strong> August–November 2026</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-spi-600 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-600"><strong>Participants:</strong> 2 Student-Athletes</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-spi-600 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-600"><strong>Dynamic Partnerships:</strong> Impactful people</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-spi-600 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-600"><strong>Cost:</strong> Free to Families</span>
                  </li>
                </ul>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Four Pillars</h3>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-spi-600 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C20.832 18.477 19.246 18 17.5 18c-1.746 0-3.332.477-4.5 1.253" />
                    </svg>
                    <span className="text-gray-600">Cyber Schooling</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-spi-600 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                    <span className="text-gray-600">Performance Training</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-spi-600 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                    </svg>
                    <span className="text-gray-600">Mental Health</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-spi-600 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                    </svg>
                    <span className="text-gray-600">NIL U</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Family Dashboard Preview */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-light text-gray-900 mb-6">Family Portal Dashboard</h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              Track your student-athlete's progress with our comprehensive family portal featuring real-time updates and seamless communication.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-spi-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <svg className="w-6 h-6 text-spi-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3a4 4 0 118 0v4m-4 12l1-3h-6l1 3m-1-3V8a1 1 0 011-1h8a1 1 0 011 1v8" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Real-Time Schedule</h3>
                  <p className="text-gray-600 text-sm">View and manage your student's training schedule, academic blocks, and wellness appointments.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 bg-spi-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <svg className="w-6 h-6 text-spi-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Progress Tracking</h3>
                  <p className="text-gray-600 text-sm">Monitor academic performance, athletic development, and wellness metrics with detailed analytics.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 bg-spi-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <svg className="w-6 h-6 text-spi-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Direct Communication</h3>
                  <p className="text-gray-600 text-sm">Stay connected with trainers and staff through secure messaging and video check-ins.</p>
                </div>
              </div>
            </div>
            
            <div className="bg-gray-50 rounded-xl p-6">
              <div className="bg-white rounded-lg p-4 shadow-sm mb-4">
                <div className="flex items-center justify-between mb-3">
                  <h4 className="font-semibold text-gray-900">Today's Schedule</h4>
                  <span className="text-sm text-gray-500">Oct 15</span>
                </div>
                <div className="space-y-2">
                  <div className="flex items-center text-sm">
                    <div className="w-2 h-2 bg-spi-600 rounded-full mr-3"></div>
                    <span className="text-gray-600">7:30am - Speed Training</span>
                  </div>
                  <div className="flex items-center text-sm">
                    <div className="w-2 h-2 bg-gray-400 rounded-full mr-3"></div>
                    <span className="text-gray-600">8:45am - Academic Block 1</span>
                  </div>
                  <div className="flex items-center text-sm">
                    <div className="w-2 h-2 bg-spi-600 rounded-full mr-3"></div>
                    <span className="text-gray-600">11:15am - Strength Training</span>
                  </div>
                </div>
              </div>
              
              <div className="bg-white rounded-lg p-4 shadow-sm">
                <h4 className="font-semibold text-gray-900 mb-3">Recent Updates</h4>
                <div className="space-y-3">
                  <div className="text-sm">
                    <p className="text-gray-600"><span className="font-medium">Dr. Monos:</span> Great progress in today's wellness session!</p>
                    <span className="text-xs text-gray-400">2 hours ago</span>
                  </div>
                  <div className="text-sm">
                    <p className="text-gray-600"><span className="font-medium">Justin King:</span> Improved 40-yard dash time by 0.2 seconds</p>
                    <span className="text-xs text-gray-400">1 day ago</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Three Pillars of Development */}
      <section className="py-16 bg-white relative">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-light text-gray-900 mb-6">Three Pillars of Development</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
              We integrate academic excellence, mental wellness, and athletic development to create well-rounded student-athletes.
            </p>
          </div>

          {/* Featured Fitness Image */}
          <div className="mb-12 rounded-2xl overflow-hidden shadow-xl">
            <img 
              src="/assets/DTS_Fitness_Allie_Lehman_Photos_ID1794.jpg"
              alt="Fitness Training"
              className="w-full h-[500px] object-cover"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gray-50 rounded-xl p-6 text-center">
              <div className="w-16 h-16 bg-spi-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-spi-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C20.832 18.477 19.246 18 17.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Academic Preparation</h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                Rigorous, NCAA-accredited coursework designed for aspiring student-athletes.
              </p>
              <a 
                href="https://gouspa.org" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-spi-600 hover:text-spi-700 font-medium text-sm"
              >
                Learn More →
              </a>
            </div>

            <div className="bg-gray-50 rounded-xl p-6 text-center">
              <div className="w-16 h-16 bg-spi-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-spi-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Mental Wellness</h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                Comprehensive social-emotional learning through Second Step program.
              </p>
              <a 
                href="https://www.youtube.com/watch?v=secondstep" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-spi-600 hover:text-spi-700 font-medium text-sm"
              >
                Watch Video →
              </a>
            </div>

            <div className="bg-gray-50 rounded-xl p-6 text-center">
              <div className="w-16 h-16 bg-spi-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-spi-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Sport-Specific Training</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Personalized training through Team Beast Mode with specialized speed training and recovery protocols.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Training Gallery */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl font-light text-gray-900 mb-8 text-center">Training in Action</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="rounded-xl overflow-hidden shadow-lg">
              <img 
                src="/assets/DTS_Warm_Up_Daniel_Farò_Photos_ID7100.jpg"
                alt="Warm Up Session"
                className="w-full h-80 object-cover hover:scale-105 transition-transform duration-300"
              />
              <div className="p-4 bg-white">
                <h3 className="font-semibold text-gray-900">Dynamic Warm-Up</h3>
                <p className="text-sm text-gray-600 mt-1">Preparing athletes for peak performance</p>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg">
              <img 
                src="/assets/DTS_Warm_Up_Daniel_Farò_Photos_ID7104.jpg"
                alt="Training Session"
                className="w-full h-80 object-cover hover:scale-105 transition-transform duration-300"
              />
              <div className="p-4 bg-white">
                <h3 className="font-semibold text-gray-900">Personalized Coaching</h3>
                <p className="text-sm text-gray-600 mt-1">One-on-one attention for optimal development</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sample Schedule Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-light text-gray-900 mb-6">Sample Daily Schedule</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Our structured daily schedule balances athletic training, academic excellence, and personal development.
            </p>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <div className="grid grid-cols-1 divide-y divide-gray-200">
            
                <div className="p-6 flex items-center justify-between hover:bg-gray-50 transition-colors">
                  <div className="flex items-center">
                    <span className="text-2xl font-bold text-spi-600 min-w-[100px] mr-6">7:30am</span>
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900">Speed Training</h4>
                      <p className="text-gray-600">with Justin King</p>
                    </div>
                  </div>
                  <div className="w-10 h-10 bg-spi-100 rounded-full flex items-center justify-center">
                    <svg className="w-5 h-5 text-spi-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  </div>
                </div>

                <div className="p-6 flex items-center justify-between hover:bg-gray-50 transition-colors">
                  <div className="flex items-center">
                    <span className="text-2xl font-bold text-gray-600 min-w-[100px] mr-6">8:45am</span>
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900">Academic Block 1</h4>
                      <p className="text-gray-600">Core curriculum studies</p>
                    </div>
                  </div>
                  <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
                    <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C20.832 18.477 19.246 18 17.5 18c-1.746 0-3.332.477-4.5 1.253" />
                    </svg>
                  </div>
                </div>

                <div className="p-6 flex items-center justify-between hover:bg-gray-50 transition-colors">
                  <div className="flex items-center">
                    <span className="text-2xl font-bold text-spi-600 min-w-[100px] mr-6">11:15am</span>
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900">Strength & Core Training</h4>
                      <p className="text-gray-600">with Team Beast Mode</p>
                    </div>
                  </div>
                  <div className="w-10 h-10 bg-spi-100 rounded-full flex items-center justify-center">
                    <svg className="w-5 h-5 text-spi-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 4v12l-4-2-4 2V4M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </div>
                </div>

                <div className="p-6 flex items-center justify-between hover:bg-gray-50 transition-colors">
                  <div className="flex items-center">
                    <span className="text-2xl font-bold text-gray-600 min-w-[100px] mr-6">12:30pm</span>
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900">Lunch & Wellness Check</h4>
                      <p className="text-gray-600">Zoom session with Dr. Monos</p>
                    </div>
                  </div>
                  <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
                    <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                    </svg>
                  </div>
                </div>

                <div className="p-6 flex items-center justify-between hover:bg-gray-50 transition-colors">
                  <div className="flex items-center">
                    <span className="text-2xl font-bold text-gray-600 min-w-[100px] mr-6">1:15pm</span>
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900">Academic Block 2</h4>
                      <p className="text-gray-600">Continued studies & projects</p>
                    </div>
                  </div>
                  <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
                    <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C20.832 18.477 19.246 18 17.5 18c-1.746 0-3.332.477-4.5 1.253" />
                    </svg>
                  </div>
                </div>

                <div className="p-6 flex items-center justify-between hover:bg-gray-50 transition-colors">
                  <div className="flex items-center">
                    <span className="text-2xl font-bold text-gray-600 min-w-[100px] mr-6">3:15pm</span>
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900">Flexibility Training</h4>
                      <p className="text-gray-600">Recovery & mobility work</p>
                    </div>
                  </div>
                  <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
                    <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                    </svg>
                  </div>
                </div>

                <div className="p-6 flex items-center justify-between hover:bg-gray-50 transition-colors">
                  <div className="flex items-center">
                    <span className="text-2xl font-bold text-gray-600 min-w-[100px] mr-6">3:45pm</span>
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900">Journal & Reflection</h4>
                      <p className="text-gray-600">Daily goal setting & review</p>
                    </div>
                  </div>
                  <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
                    <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                    </svg>
                  </div>
                </div>

                <div className="p-6 flex items-center justify-between hover:bg-gray-50 transition-colors">
                  <div className="flex items-center">
                    <span className="text-2xl font-bold text-gray-600 min-w-[100px] mr-6">Evening</span>
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900">Rest & Recovery</h4>
                      <p className="text-gray-600">Socialization & personal time</p>
                    </div>
                  </div>
                  <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
                    <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Student Profile Section */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl font-light text-gray-900 text-center mb-8">
            Profile of a Sonom Performance Institute Student
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {/* Inspired Innovator */}
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl p-6 border border-orange-200">
              <div className="w-12 h-12 bg-orange-200 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Inspired Innovator</h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                A student who seeks to push boundaries and redefine what's possible. They are driven to explore new ideas and approaches, both on and off the field, constantly seeking ways to improve themselves and their team.
              </p>
            </div>
            
            {/* Critical Thinker */}
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-6 border border-blue-200">
              <div className="w-12 h-12 bg-blue-200 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Critical Thinker</h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                Analyzes complex situations and makes well-informed decisions. They see the bigger picture, understand team dynamics, think strategically, anticipate challenges, and develop solutions for success.
              </p>
            </div>
            
            {/* Responsible Collaborator */}
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-6 border border-green-200">
              <div className="w-12 h-12 bg-green-200 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Responsible Collaborator</h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                Understands the value of teamwork and is committed to working effectively with others. They communicate clearly, listen actively, contribute ideas, and are reliable, accountable, and supportive teammates.
              </p>
            </div>
            
            {/* Lifelong Learner */}
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl p-6 border border-purple-200">
              <div className="w-12 h-12 bg-purple-200 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C20.832 18.477 19.246 18 17.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Lifelong Learner</h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                Committed to continuous improvement and personal growth. They are curious, open-minded, eager to explore new ideas and experiences, self-motivated, and proactive in seeking challenges and opportunities.
              </p>
            </div>
            
            {/* Effective Communicator */}
            <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-2xl p-6 border border-red-200">
              <div className="w-12 h-12 bg-red-200 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Effective Communicator</h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                Able to express themselves clearly and persuasively. They adapt their communication style to different audiences, ensuring their message is understood and well-received with empathy and respect.
              </p>
            </div>
            
            {/* Global Citizen */}
            <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-2xl p-6 border border-indigo-200">
              <div className="w-12 h-12 bg-indigo-200 rounded-lg flex items-center justify-center mb-4">
                <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Global Citizen</h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                Aware of the broader world and their place in it. They are respectful of cultural differences, committed to making a positive impact through athletic achievements, academic pursuits, or community service.
              </p>
            </div>
          </div>
          
          {/* Student Prospects */}
          <div className="bg-spi-50 rounded-2xl p-8 border-2 border-spi-200">
            <h3 className="text-2xl font-light text-gray-900 mb-6 text-center">Student Prospects for Pilot Program</h3>
            <div className="text-center">
              <p className="text-lg text-gray-700 mb-4">
                We are seeking <strong>2 exceptional student-athletes</strong> for our pilot program:
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto">
                <div className="bg-white rounded-xl p-6 shadow-md">
                  <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <svg className="w-8 h-8 text-pink-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  </div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">1 Female Athlete</h4>
                  <p className="text-sm text-gray-600">Winter or Spring Sports</p>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-md">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  </div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">1 Male Athlete</h4>
                  <p className="text-sm text-gray-600">Winter or Spring Sports</p>
                </div>
              </div>
              <p className="text-gray-600 mt-6 text-sm italic">
                *Fall sport athletes are welcome after consultation with Dr. Monos to ensure proper workload balance
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Program Overview - WHO/WHAT/WHERE/WHEN/WHY/HOW */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <h2 className="text-3xl font-light text-gray-900 text-center mb-12">
            Program Framework
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* WHO */}
            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="bg-red-500 text-white px-4 py-2 rounded-lg inline-block mb-4">
                <span className="font-semibold">WHO</span>
              </div>
              <p className="text-gray-700 leading-relaxed">
                2 Students/Families in Grades 7-8 for August of 2026, who are highly motivated and focused on a specific winter or Spring sport training regimen and/or wellness.
              </p>
            </div>
            
            {/* WHAT */}
            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="bg-red-400 text-white px-4 py-2 rounded-lg inline-block mb-4">
                <span className="font-semibold">WHAT</span>
              </div>
              <p className="text-gray-700 leading-relaxed">
                Our objective is to maximize the potential of every student. Sonom Performance Institute aims to become the leading preparatory academy by providing world-class instruction, offering a four-month proof of concept experience. Free to the family.
              </p>
            </div>
            
            {/* WHERE */}
            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="bg-red-300 text-white px-4 py-2 rounded-lg inline-block mb-4">
                <span className="font-semibold">WHERE</span>
              </div>
              <p className="text-gray-700 leading-relaxed">
                Students attend Team Beast Mode Training for an in-person program experience. Even with online schooling affording flexibility in physical location, students' personalized programming is best facilitated in a welcoming, structured learning environment.
              </p>
            </div>
            
            {/* WHEN */}
            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="bg-orange-400 text-white px-4 py-2 rounded-lg inline-block mb-4">
                <span className="font-semibold">WHEN</span>
              </div>
              <p className="text-gray-700 leading-relaxed">
                August-November 2026-27 School Year
              </p>
            </div>
            
            {/* WHY */}
            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="bg-orange-300 text-white px-4 py-2 rounded-lg inline-block mb-4">
                <span className="font-semibold">WHY</span>
              </div>
              <p className="text-gray-700 leading-relaxed">
                The purpose of this venture is to support the holistic development of each student, focusing on the role a preparatory program can play.
              </p>
            </div>
            
            {/* HOW */}
            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="bg-yellow-400 text-white px-4 py-2 rounded-lg inline-block mb-4">
                <span className="font-semibold">HOW</span>
              </div>
              <p className="text-gray-700 leading-relaxed">
                To initiate student recruitment, we will leverage our network of participating facilities' coaches and trainers. Additionally, we will reach out to local sports organizations within a 20-mile radius. Our goal is to interview 200 families in the Lancaster City and 10-mile radius surrounding area, ultimately enrolling 2 students/families.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Original Pilot Details Section - Now includes schedule above */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="bg-gray-50 rounded-2xl p-8 shadow-lg mb-12">
            <h2 className="text-3xl font-light text-gray-900 mb-8 text-center">
              What the R&D Pilot Includes
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h4 className="text-xl font-semibold text-gray-900 mb-4">Program Details</h4>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-spi-600 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-600"><strong>Duration:</strong> August–November 2026</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-spi-600 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-600"><strong>Participants:</strong> 2 cyber-schooling student-athletes</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-spi-600 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-600">Personalized training</span>
                  </li>
                </ul>
              </div>
              
              <div>
                <h4 className="text-xl font-semibold text-gray-900 mb-4">Program Components</h4>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-spi-600 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-600">Mental health curriculum</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-spi-600 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-600">NIL Simulation</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-spi-600 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-600">Nutrition + transport support</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-5 h-5 text-spi-600 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-gray-600">Embedded performance consultation</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Dynamic Partnerships */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-light text-gray-900 mb-6">Dynamic Partnerships</h2>
            <p className="text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto">
              Get to know the dedicated professionals at Sonom Performance Institute who are committed to delivering 
              a holistic and enriching educational experience for your child.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {partners.map((partner, index) => (
              <div key={index} className="bg-gray-50 rounded-2xl p-6 text-center hover:shadow-lg transition-shadow">
                {partnerImages[partner.name] ? (
                  <div className="w-20 h-20 mx-auto mb-4 rounded-xl overflow-hidden bg-gray-100 flex items-center justify-center">
                    <img
                      src={partnerImages[partner.name]}
                      alt={partner.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                ) : (
                  <div className="w-16 h-16 bg-spi-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                    <div className="text-spi-600">
                      {partner.icon}
                    </div>
                  </div>
                )}
                <h4 className="text-lg font-semibold text-gray-900 mb-2">{partner.name}</h4>
                <p className="text-spi-600 font-medium mb-2">{partner.role}</p>
                {partner.partnership && (
                  <p className="text-sm text-gray-500">{partner.partnership}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Family Testimonials */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-light text-gray-900 mb-4">What Families Are Saying</h2>
            <p className="text-sm text-gray-500">
              Note: The examples provided below are hypothetical and do not represent real comments.
            </p>
          </div>
        </div>
      </section>

      {/* The Program Section - Similar to Academy section */}
      <section className="py-24 bg-spi-800 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-gradient-to-r from-spi-900/90 to-spi-800/70"></div>
        </div>
        <div className="relative max-w-6xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-light mb-6 tracking-tight">Program Outcomes & Toolkit</h2>
            <p className="text-xl text-spi-100 font-light max-w-3xl mx-auto leading-relaxed">
              Our comprehensive approach delivers measurable results through evidence-based methods and continuous family engagement.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 hover:bg-white/15 transition-all duration-300">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-6">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-4">Holistic Excellence</h3>
              <p className="text-spi-100 font-light">
                Empower students to excel academically, socially, and athletically through integrated development.
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 hover:bg-white/15 transition-all duration-300">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-6">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-4">Data-Driven Growth</h3>
              <p className="text-spi-100 font-light">
                Track progress and measure development through evidence-based assessment and continuous monitoring.
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 hover:bg-white/15 transition-all duration-300">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-6">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-4">Family Partnership</h3>
              <p className="text-spi-100 font-light">
                Engage families as active partners in the development process with regular feedback and insights.
              </p>
            </div>
          </div>

          <div className="text-center">
            <h3 className="text-2xl font-light mb-6">Ready to shape the future of student-athlete development?</h3>
            <div className="flex justify-center gap-4">
              <a 
                href="mailto:sonom.advantage@gmail.com" 
                className="bg-white text-spi-900 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-all duration-300 transform hover:scale-105"
              >
                Apply Now
              </a>
              <a 
                href="#program-details" 
                className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-spi-900 transition-all duration-300"
              >
                Learn More
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Research2026;